"use client";

import { SafeHydrate } from "./safe-hydrate";

export const withSafeHydration =
  <Props extends Record<string, unknown>>(Component: React.ComponentType<Props>) =>
  (props: Props) => (
    <SafeHydrate>
      <Component {...props} />
    </SafeHydrate>
  );
